import React, {useContext, useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {Container, Row, Col} from "react-bootstrap";
import './MaxiProfile.css';
import ProfilePhoto from "./ProfilePhoto/ProfilePhoto";
import StatusBar from "../StatusBar/StatusBar";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import NavigationBar from "./NavigationBar/NavigationBar";
import {ModalContext} from "../../contexts/modal/ModalContext";
import {LoadingContext} from "../../contexts/loading/LoadingContext";
import {getAge} from "../../utils/MaxiUtil";
import messages from "../../i18n/messages";

const MaxiProfile = () => {
    const intl = useIntl();
    const [ageState, setAgeState] = useState(0);
    const [renderState, setRenderState] = useState(false);
    const [, setModalContext] = useContext(ModalContext);
    const [, setLoadingContext] = useContext(LoadingContext);

    useEffect(() => {
        requestForAge();
    }, []);

    async function requestForAge() {
        try {
            setLoadingContext({
                isLoading: true,
                loadingText: '',
            });
            const response = await getAge();
            if (response.ok) {
                const data = await response.json();

                setAgeState(data);
            } else {
                setModalContext({
                    isShow: true,
                    title: intl.formatMessage(messages.errMsgTitle),
                    content: intl.formatMessage(messages.errMsgServerError),
                    onConfirm: () => {},
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContext({
                isLoading: false,
                loadingText: '',
            });
            setRenderState(true);
        }
    }

    if (renderState && ageState > 0) {
        return (
            <Container fluid>
                <StatusBar />
                <Row className='profile-content'>
                    <Col lg={12} xl={6} className={'content-container'}>
                        <NavigationBar />
                        <Row>
                            <Col xs={12} className={'profile-text'}>
                                <PersonalDetails ageProp={ageState}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12} xl={6}>
                        <ProfilePhoto />
                    </Col>
                </Row>
            </Container>
        );
    }

    return <></>;
}
export default MaxiProfile;